import { ABNORMAL_STATE } from '@app/constants/abnormalState'
import { TABLE_ROW_COLORS } from '@app/constants'

import type { AbnormalState } from '@app/types'

export const getCompetitorsPricesRowClassName = (abnormalState: AbnormalState | null): string => {
  switch (abnormalState) {
    case ABNORMAL_STATE.ABNORMAL:
      return TABLE_ROW_COLORS.yellow
    default:
      return ''
  }
}
